/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
/* eslint-disable no-dupe-keys */

import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';
import Form from "react-bootstrap/Form";
import PropTypes from 'prop-types';
import { registerUser, getOccupations, getSports } from '../../../actions/auth';
import { setAlert } from '../../../actions/alert';
import { FadeLoader } from "react-spinners";
import { useForm, Controller } from "react-hook-form";
import moment from "moment-timezone";
import { REGISTER_PURGE } from "../../../actions/types";
import { LoginMain } from '../../../styles/common.style';
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import DatePicker from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";

// US states + DC + "Other" for the demographic State dropdown added 2026-05-26
// (paired with Backend PR #201 which landed user_details.state VARCHAR(64)).
// Hardcoded rather than fetched — the 50-states set is stable enough that the
// maintenance cost of an admin states CRUD isn't worth the runtime fetch.
// Stored as the full state name string ("Utah", not "UT") to match what
// user_details.state holds + what the FRT script sends.
const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Other',
];

const Signup = ({ setAlert, registerUser, loading, hasRegistered, getOccupations, occupations, getSports, sports }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    dob: "",
    password_confirmation: "",
  });

  const [check, setCheck] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [email, setEmail] = useState(null)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [value, setValue] = useState('')
  const [inputType, setInputType] = useState("text");
  const [showOther, setShowOther] = useState(false);
  const [showOtherOcc, setShowOtherOcc] = useState(false);
  const dob = useRef();
  const { register, control, watch, handleSubmit, setError, clearErrors, formState: { errors } } = useForm({
    mode: "onBlur",
  });
  const regex = new RegExp("^[\\+]?[(]?[0-9]{1,4}[)]?[-\\s\\.]?[0-9]{1,4}[-\\s\\.]?[0-9]{1,4}[-\\s\\.]?[0-9]{1,12}$");
  const dispatch = useDispatch();

  useEffect(() => {
    getOccupations(0, 0, 0)
    getSports(0, 0, 0)
    const body = document.querySelector('#root');
    body.scrollIntoView({
      behavior: 'smooth'
    }, 500)
    setTimeout(() => {
      const elements = document.querySelectorAll(".PhoneInputCountryIconImg");

      elements.forEach(element => {
        element.setAttribute('crossOrigin', 'anonymous');
      });
    }, 1500);
  }, [])
  let navigate = useNavigate();
  const toHome = () => navigate("/", { replace: true })
  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const password = useRef({});
  password.current = watch("password", "");

  const onSubmit = (data) => {
    setEmail(data.email);
    const formattedDate = data.dob
    let form = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      phone: value ? value : '',
      password: data.password,
      dob: formattedDate,
      password_confirmation: data.password_confirmation,
      occupation_id: data.occupation_id,
      weight_unit: data.weight_unit,
      gender: data.gender,
      user_sports: [data.user_sports],
      other_sport: data.other_sport,
      other_occupation: data.other_occupation,
      // US-state demographic field (Backend PR #201, 2026-05-26). Stored
      // as user_details.state VARCHAR(64); enables cohort queries across
      // the user base for Angela's clinical analysis.
      state: data.state,
    }
    if (!check) {
      setAlert('Need to agree to our terms and conditions', 'danger');
    }
    else {
      registerUser(form);
    }
  };

  const validateInternationalPhoneNumber = (phoneNumber) => {
    const internationalPhonePattern = /^\+\d+$/;
    return internationalPhonePattern.test(phoneNumber);
  };

  if (hasRegistered) {
    dispatch({ type: REGISTER_PURGE })
    navigate("/verify-email", { state: { email } })
  }

  const handlePhoneChange = (number) => {
    if (number?.length > 0 && isValidPhoneNumber(number)) {
      clearErrors('phone')
      setValue(number)
    } else {
      setError('phone', { message: (number ? (isValidPhoneNumber(number) ? undefined : 'Invalid phone number') : 'Phone number required') });
    }

  };

  const handleChange = (e) => {
    const selectedId = e.target.value;
    const selectedSport = sports.find((sport) => sport.id == selectedId);
    setShowOther(selectedSport.name === "Other");
  };

  const handleChangeOcc = (e) => {
    const selectedId = e.target.value;
    const selectedOccupation = occupations.find((occupation) => occupation.id == selectedId);
    setShowOtherOcc(selectedOccupation.name === "Other");
  };

  const containsSpecialChars = (value) => {
    const specialChars = /[!@#$%^&*()_+\-=\[\]{};':",\\|,.<>\/?]+/; // Define special characters
    return specialChars.test(value);
  };

  const containsSpaces = (value) => {
    return /^\s|\s$/.test(value);
  };

  const validatePassword = (value) => {
    const hasCapitalLetter = /[A-Z]/.test(value);
    const hasSymbol = /[!@#$%^&*()_+\-=\[\]{};':",\\|,.<>\/?]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasLowercase = /[a-z]/.test(value);

    if (!hasCapitalLetter) {
      return "Password must contain at least one capital letter.";
    }
    if (!hasSymbol) {
      return "Password must contain at least one symbol.";
    }
    if (!hasNumber) {
      return "Password must contain at least one number.";
    }
    if (!hasLowercase) {
      return "Password must contain at least one lowercase letter.";
    }

    return true; // All conditions met
  };

  return (
    <div>
      <LoginMain className='register-main-login'>
        <div className='login-main-block'>
          <div className='login-main-block-left'>
            <div className='login-main-block-left-link'>
              <Link to='/'>
                {/* <img src='/images/auth-logo.svg' alt='img' /> */}
                <img src='/images/logo-auth-2.png' alt='img' />
              </Link>
            </div>
            <div className='login-main-block-left-banner'>
              <img src='/images/login-banner.png' alt='login-banner' />
              {/* <img src='/images/img42.png' alt='login-banner' /> */}
            </div>
            <div className='title-block'>
              <h1>Welcome</h1>
            </div>
          </div>
          <div className='login-main-block-right'>
            {/* <LoginForm /> */}
            <div className='login-form-block'>
              <div className='login-form-block-title'>
                <h2>Create Account</h2>
              </div>
              <Form onSubmit={handleSubmit(onSubmit)} id='call_form' className='form-main sign-up-form'>
                {loading && (
                  <div className="loader-overlay">
                    <FadeLoader color={'#FB1417'} loading={loading} />
                  </div>
                )}
                <div className='form-two-group before-none'>
                  <div className='form-two-group-inner '>
                    <Form.Group className='form_signup'>
                      <Form.Control
                        className='form-control form-1 user_img'
                        placeholder='First Name'
                        name='name'
                        {...register('first_name', {
                          required: {
                            value: 'required',
                            message: 'First Name is required'
                          },
                          minLength: {
                            value: 3,
                            message: 'First Name too short.'
                          },
                          maxLength: {
                            value: 40,
                            message: 'First Name is too long - should be at most 40 characters.'
                          },
                          validate: {
                            specialChars: (value) => !containsSpecialChars(value) || 'Username must contain only letters.',
                            noSpaces: (value) => !containsSpaces(value) || 'Spaces are not allowed.' // New rule
                          }
                        })}
                        type='text'
                      />
                      {errors.first_name && <Form.Text className='validationText hasError'>{errors.first_name.message}</Form.Text>}
                      <div className='form-sign-icon'>
                        <img src='/images/user-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>
                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      <Form.Control
                        className='form-control form-1 user_img'
                        placeholder='Last Name'
                        name='name'
                        {...register('last_name', {
                          required: {
                            value: 'required',
                            message: 'Last Name is required'
                          },
                          minLength: {
                            value: 3,
                            message: 'Last too short.'
                          },
                          maxLength: {
                            value: 40,
                            message: 'Last Name is too long - should be at most 40 characters.'
                          },
                          validate: {
                            specialChars: (value) => !containsSpecialChars(value) || 'Username must contain only letters.',
                            noSpaces: (value) => !containsSpaces(value) || 'Spaces are not allowed.' // New rule
                          }
                        })}
                        type='text'
                      />
                      {errors.last_name && <Form.Text className='validationText hasError'>{errors.last_name.message}</Form.Text>}
                      <div className='form-sign-icon'>
                        <img src='/images/user-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>

                </div>

                <Form.Group className='form_signup'>
                  <Form.Control
                    className='form-control'
                    placeholder='Email Address'
                    name='email'
                    {...register('email', {
                      required: {
                        value: 'required',
                        message: 'Email is required'
                      },
                      pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: 'Please enter a valid email.'
                      },
                      maxLength: {
                        value: 255,
                        message: 'Max length is 255'
                      }
                    })}
                    type='email'
                  />
                  {errors.email && <Form.Text className='validationText hasError'>{errors.email.message}</Form.Text>}
                  <div className='form-sign-icon'>
                    <img src='/images/mail-icon.svg' alt='icon-block' />
                  </div>
                </Form.Group>
                <Form.Group className='form_signup' controlId='phone'>
                  <PhoneInput
                    name='phone'
                    limitMaxLength={20}
                    className='phone-input'
                    placeholder='Mobile Number'
                    international
                    value={value}
                    defaultCountry='US'
                    onChange={handlePhoneChange}
                  />
                  {errors.phone && <Form.Text className='validationText hasError'>{errors.phone.message}</Form.Text>}
                  {/* <div className='form-sign-icon'>
                    <img src='/images/mail-icon.svg' alt='icon-block' />
                  </div> */}
                </Form.Group>
                {/* Birthday + State paired in a two-column row (Angela 2026-05-26
                    UX feedback). DOB was previously a full-width row with a
                    floating-label that wasn't visibly rendering "Date of Birth";
                    State was added in a standalone full-width row that looked
                    oversized next to Gender/Sport. Both now sit at the same
                    column width as Gender/Wt. Unit + Occupation/Sport above. */}
                <div className='form-two-group'>
                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      {/* <Controller
                        name="dob"
                        control={control}
                        rules={{
                          required: "Date of Birth is required",
                          validate: (value) => {
                            if (!value) return "Date of Birth is required";
                            const today = new Date();
                            return value < today || "Date cannot be in the future";
                          },
                        }}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            selected={field.value}
                            onChange={(date) => field.onChange(date)}
                            placeholderText="DD/MM/YYYY" // ✅ Works perfectly
                            dateFormat="dd/MM/yyyy"
                            maxDate={new Date()}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={100}
                            className="form-control"
                            autoComplete="off"
                          />
                        )}
                      />
                      {errors.dob && <Form.Text className='validationText hasError'>{errors.dob.message}</Form.Text>} */}

                      {/* "DOB MM/DD/YYYY" placeholder rendered INSIDE the box
                          (Angela 2026-05-26 UX: keep all field labels inline
                          like First Name / Email / etc — no separate label
                          above). Native type='date' inputs render the browser's
                          own "mm/dd/yyyy" widget and ignore the placeholder
                          attribute, so we start the field as type='text' (which
                          shows our placeholder) and swap to type='date' on focus
                          so the user gets the native date picker once they tap
                          in. On blur with no value we swap back so the
                          placeholder reappears. */}
                      <Form.Control
                        type='text'
                        className='form-control'
                        placeholder='DOB MM/DD/YYYY'
                        name='dob'
                        max={moment().format('YYYY-MM-DD')}
                        onFocus={(e) => { e.target.type = 'date' }}
                        onBlur={(e) => { if (!e.target.value) e.target.type = 'text' }}
                        {...register('dob', {
                          required: {
                            value: 'required',
                            message: 'DOB is required'
                          }
                        })}
                      />
                      {errors.dob && <Form.Text className='validationText hasError'>{errors.dob.message}</Form.Text>}
                      <div className='form-sign-icon'>
                        <img src='/images/calendar-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>
                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      <Form.Select
                        placeholder='Select State'
                        className=''
                        id={'state'}
                        {...register('state', {
                          required: {
                            value: 'required',
                            message: 'State is required'
                          }
                        })}
                      >
                        <option value='' selected={true} disabled={true}>
                          Select State
                        </option>
                        {US_STATES.map((stateName) => (
                          <option key={stateName} value={stateName}>{stateName}</option>
                        ))}
                      </Form.Select>
                      {errors.state && (
                        <Form.Text className='validationText hasError'>{errors.state.message}</Form.Text>
                      )}
                      <div className='form-sign-icon'>
                        <img src='/images/map-pin-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>
                </div>
                <Form.Group className='form_signup'>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    className='form-control'
                    placeholder='Password'
                    id='password-field'
                    name='password'
                    {...register('password', {
                      required: {
                        value: 'required',
                        message: 'Password is required'
                      },
                      minLength: {
                        value: 8,
                        message: 'Password is too short-should be at least 8 characters.'
                      },
                      maxLength: {
                        value: 255,
                        message: 'Max length is 255'
                      },
                      validate: validatePassword
                    })}
                  />
                  <span
                    toggle='#password-field'
                    className={
                      showPassword
                        ? 'fa fa-fw fa-eye field-icon toggle-password'
                        : 'fa fa-fw fa-eye-slash field-icon toggle-password '
                    }
                    onClick={() => setShowPassword(!showPassword)}></span>
                  {errors.password && (
                    <Form.Text className='validationText hasError'>{errors.password.message}</Form.Text>
                  )}
                  <Form.Text style={{ fontSize: "12px", color: "green" }} className=''>Use at least 1 uppercase, 1 symbol, 1 number, and 1 lowercase letter.</Form.Text>
                  <div className='form-sign-icon'>
                    <img src='/images/password-icon.svg' alt='icon-block' />
                  </div>

                </Form.Group>
                <Form.Group className='form_signup'>
                  <Form.Control
                    type={showConfirmPassword ? 'text' : 'password'}
                    className='form-control form-1 pass_img'
                    placeholder='Confirm Password '
                    id='password-field1'
                    name='password_confirmation'
                    {...register('password_confirmation', {
                      required: {
                        value: 'required',
                        message: 'Confirm Password is required'
                      },
                      minLength: {
                        value: 8,
                        message: 'Min length is 8'
                      },
                      validate: password.current
                        ? (value) => value === password.current || 'Confirm password must be the same as the password.'
                        : '',
                      maxLength: {
                        value: 255,
                        message: 'Max length is 255'
                      },
                      validate: validatePassword
                    })}
                  />
                  <span
                    toggle='#password-field1'
                    className={
                      showConfirmPassword
                        ? 'fa fa-fw fa-eye field-icon toggle-password'
                        : 'fa fa-fw fa-eye-slash field-icon toggle-password '
                    }
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}></span>

                  {errors.password_confirmation && (
                    <Form.Text className='validationText hasError'>{errors.password_confirmation.message}</Form.Text>
                  )}
                  <Form.Text style={{ fontSize: "12px", color: "green" }} className=''>Use at least 1 uppercase, 1 symbol, 1 number, and 1 lowercase lette</Form.Text>
                  <div className='form-sign-icon'>
                    <img src='/images/password-icon.svg' alt='icon-block' />
                  </div>
                </Form.Group>
                <div className='form-two-group'>
                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      <Form.Select
                        placeholder='Select Gender'
                        className=''
                        id={'gender'}
                        {...register('gender', {
                          required: {
                            value: 'required',
                            message: 'Gender is required'
                          }
                        })}>
                        <option value='' selected={true} disabled={true}>
                          Select Gender
                        </option>
                        <option value={20}>Female</option>
                        <option value={10}>Male</option>
                      </Form.Select>
                      {errors.gender && (
                        <Form.Text className='validationText hasError'>{errors.gender.message}</Form.Text>
                      )}
                      <div className='form-sign-icon'>
                        <img src='/images/gender-symbols-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>
                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      <Form.Select
                        placeholder='Select Weight Unit'
                        className=''
                        id={'weight_unit'}
                        {...register('weight_unit', {
                          required: {
                            value: 'required',
                            message: ' Weight unit is required'
                          }
                        })}>
                        <option value='' selected={true} disabled={true}>
                          Select Wt. Unit
                        </option>
                        <option value={10}>Kg</option>
                        <option value={20}>Lbs</option>
                      </Form.Select>
                      {errors.weight_unit && (
                        <Form.Text className='validationText hasError'>{errors.weight_unit.message}</Form.Text>
                      )}
                      <div className='form-sign-icon'>
                        <img src='/images/weight-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>
                </div>
                <div className='form-two-group'>
                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      <Form.Select
                        placeholder='Select Occupation'
                        className=''
                        id={'occupation_id'}
                        {...register('occupation_id', {
                          required: {
                            value: 'required',
                            message: 'Occupation is required'
                          }
                        })}
                        onChange={handleChangeOcc}
                      >
                        <option value='' selected={true} disabled={true}>
                          Select Occupation
                        </option>
                        {occupations &&
                          occupations?.map((occupation, index) => (
                            <option value={occupation.id}>{occupation.name}</option>
                          ))}
                      </Form.Select>
                      {errors.occupation_id && (
                        <Form.Text className='validationText hasError'>{errors.occupation_id.message}</Form.Text>
                      )}
                      <div className='form-sign-icon'>
                        <img src='/images/person-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>

                  <div className='form-two-group-inner'>
                    <Form.Group className='form_signup'>
                      <Form.Select
                        placeholder='Select Sports'
                        className=''
                        id={'user_sports'}
                        {...register('user_sports', {
                          required: {
                            value: 'required',
                            message: 'Sport is required'
                          }
                        })}
                        onChange={handleChange}
                      >
                        <option value='' selected={true} disabled={true}>
                          Select Sport
                        </option>
                        {sports && sports?.map((sport, index) => <option value={sport.id}>{sport.name}</option>)}
                      </Form.Select>
                      {errors.user_sports && (
                        <Form.Text className='validationText hasError'>{errors.user_sports.message}</Form.Text>
                      )}

                      <div className='form-sign-icon'>
                        <img src='/images/sport-icon.svg' alt='icon-block' />
                      </div>
                    </Form.Group>
                  </div>
                </div>
                {showOtherOcc && (

                  <Form.Group className='form_signup'>
                    <Form.Control
                      className='form-control form-1 user_img'
                      placeholder='Other Occupation'
                      name='other_occupation'
                      {...register('other_occupation', {})}
                      type='text'
                    />
                  </Form.Group>

                )}
                {showOther && (

                  <Form.Group className='form_signup'>
                    <Form.Control
                      className='form-control form-1 user_img'
                      placeholder='Other Sport'
                      name='other_sport'
                      {...register('other_sport', {})}
                      type='text'
                    />
                  </Form.Group>

                )}
                <div className='checkbox-block'>
                  <div className='checkbox-filter-block'>
                    <input
                      {...register('terms', { required: 'Please accept the terms & conditions.' })}
                      type='checkbox'
                      id='demo'
                      value={check}
                      onClick={() => setCheck(!check)}></input>
                    <label htmlFor='demo'>
                      <span>
                        <img src='/images/check-icon.svg' alt='icon-block' />
                      </span>
                      <div className='flex-block-check'>
                        <p>
                          I have read and agree to the{' '}
                          <Link to='/pages/terms-and-conditions'>Terms and Conditions.</Link>
                        </p>
                      </div>
                    </label>
                  </div>
                  {errors.terms && <Form.Text className='validationText hasError'>{errors.terms.message}</Form.Text>}
                </div>
                <div className='bottom-auth-block'>
                  <div className='common-btn-main'>
                    <button className='btn btn-common-auth' disabled={loading}>Sign up</button>
                  </div>
                  <p className='sign-text-block'>
                    Already have an account? <Link to='/login'>Sign in</Link>
                  </p>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </LoginMain>
    </div>
  );
}
Signup.propTypes = {
  loading: PropTypes.bool.isRequired,
  setAlert: PropTypes.func.isRequired,
  registerUser: PropTypes.func.isRequired,
  hasRegistered: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  loading: state.auth.loading,
  hasRegistered: state.auth.hasRegistered,
  occupations: state.auth.occupations,
  sports: state.auth.sports
});

export default connect(mapStateToProps, { setAlert, registerUser, getOccupations, getSports })(Signup)


